/** USA Current Wildfires — public Esri live feed portal item. */
export const USA_CURRENT_WILDFIRES_ITEM_ID =
  'd957997ccee7408287a963600a77f61f' as const;

/** Fallback title if portal item metadata cannot be loaded. */
export const USA_CURRENT_WILDFIRES_FALLBACK_TITLE = 'USA Current Wildfires';

export function isUsaCurrentWildfiresLayer(layer: {
  arcgisItemId?: string | null;
  name?: string | null;
}): boolean {
  if (layer.arcgisItemId === USA_CURRENT_WILDFIRES_ITEM_ID) return true;
  if (layer.name?.includes(USA_CURRENT_WILDFIRES_FALLBACK_TITLE)) return true;
  return false;
}
